import React, { useEffect, createElement } from 'react';
export function PractitionersPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-395">
      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-396">
        <a href="/" data-id="element-397">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-398" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-399">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-400">
            Home
          </a>
          <a href="/practitioners" className="text-purple-700 transition-colors" data-id="element-401">
            Practitioners
          </a>
          <a href="/investors" className="hover:text-purple-700 transition-colors" data-id="element-402">
            Investors
          </a>
        </div>
      </nav>

      <section className="pt-40 pb-24 px-6" data-id="element-403">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-404">
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase text-purple-700 mb-5" data-id="element-405">
            For Practitioners
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal leading-[1.1] mb-6 tracking-tight" data-id="element-406">
            Join the Network
          </h1>
          <p className="text-lg md:text-xl text-charcoal/70 font-light leading-relaxed" data-id="element-407">
            Become part of a curated community of trusted practitioners shaping
            the future of women's wellness. Complete the form below to apply.
          </p>
        </div>

        <div className="max-w-3xl mx-auto rounded-3xl border border-purple-100 bg-white/80 backdrop-blur-md shadow-xl p-2 md:p-4" data-id="element-408">
          <div style={{
          width: '100%',
          height: 500
        }} data-fillout-id="5TKe1b8U6sus" data-fillout-embed-type="standard" data-fillout-inherit-parameters data-fillout-dynamic-resize data-id="element-409"></div>
        </div>
      </section>

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 text-center text-sm border-t border-white/10" data-id="element-410">
        <p data-id="element-411">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
      </footer>
    </main>;
}